<h1 class="title">
  {{ 'raportit.virallinen-tase' | translate | async }}
</h1>
@if (virallinenTaseDataObservable | async; as data) {
  @if (!lataa()) {
    <!-- <div *ngIf="data.e == 'a'">
    Valittu päivämääräväli ei ole millään Lemonatorista löytyvällä tilikaudella.
  </div> -->
    @if (lastSucessfullyUpdated()) {
      <div class="gray-text" style="font-size: 11px; text-align: right; line-height: 13px">{{ 'yleiset.paivitetty' | translate | async }} {{ lastSucessfullyUpdated() | ltimestamptime | async }}</div>
    }
    @if (data.c == 'c2') {
      <table class="report-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ data.c1Header }}</th>
            <th>{{ data.c2Header }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of data.data; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr class="report-row-lvl-{{ row.l }}" [class.report-row-summary]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
              <td>{{ row.s2 | lmoney | async }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (data.c == 'c1') {
      <table class="report-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ data.c1Header }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of data.data; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr class="report-row-lvl-{{ row.l }}" [class.report-row-summary]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}
